export const environment = {
    production: false,
    hmr: false,
    nombre: "Desarrollo",
    apis: "https://devapigw.pagaredigital.cl/pagare_demo",
    tokenApi: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwc1J1Y1hhaDFnRXgyeFRzdjVVMHJwIiwibmFtZSI6IlBBR0FSRV9ERU1PIiwiaWF0IjoxNjgwMTk3MzQyMjkwfQ.gYjoofcUA3xiMplojL9hNU3WewUsLBqFFUQ0_bA_DWY"
};
